import React, { useEffect } from "react";
const PIXEL_ID = "936276505813173";
declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void;
    __metaPixelLoaded?: boolean;
  }
}
export function MetaPixel() {
  useEffect(() => {
    if (window.__metaPixelLoaded) return;
    window.__metaPixelLoaded = true;
    const script = document.createElement("script");
    script.innerHTML = `!function(f,b,e,v,n,t,s)
{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];
s.parentNode.insertBefore(t,s)}(window, document,'script',
'https://connect.facebook.net/en_US/fbevents.js');
fbq('init', '${PIXEL_ID}');
fbq('track', 'PageView');`;
    document.head.appendChild(script);
  }, []);
  return <noscript data-id="element-192" data-mp="rk7egmnvkufc">
      <img height="1" width="1" style={{
      display: "none"
    }} alt="" src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} data-id="element-193" data-mp="rl0el4sbwloi" />
    </noscript>;
}